const confirmation = {
    deleteDocument: 'このドキュメントを削除してもよろしいですか？',
    unsavedChangesTitle: '未保存の入力があります',
    unsavedChanges: '保存されていない変更があります。このまま離れてもよろしいですか？',
    discardChangesTitle: '編集内容を破棄',
    discardChangesConfirm: '破棄する',
  };

export default confirmation;
